import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { D60Container } from './modals/60d/60d.container';
import { D60Component } from './modals/60d/60d.component';
import { PlanerTilGodkendelseContainer } from './modals/planer-til-godk/planer-til-godk.container';
import { PlanerTilGodkendelseComponent } from './modals/planer-til-godk/planer-til-godk.component';
import { PlanerGodkendtComponent } from './modals/planer-godkendt/planer-godkendt.component';
import { KALAComponent } from './modals/ka-la/ka-la.component';
import { SAKAComponent } from './modals/sa-ka/sa-ka.component';
import { AutorisationerComponent } from './modals/autorisationer/autorisationer.component';
import { PopupsContainer } from './modals/popups/popups.container';
import { PopupsComponent } from './modals/popups/popups.component';
import { SamtalelogComponent } from './modals/samtalelog/samtalelog.component';
import { AutorisationerContainer } from './modals/autorisationer/autorisationer.container';
import { PlanerGodkendtContainer } from './modals/planer-godkendt/planer-godkendt.container';
import { KALAContainer } from './modals/ka-la/ka-la.container';
import { SAKAContainer } from './modals/sa-ka/sa-ka.container';
import { SamtalelogContainer } from './modals/samtalelog/samtalelog.container';
import { RegnskabsaarTilGodkendelseComponent } from './modals/regnskabsaar-til-godkendelse/regnskabsaar-til-godkendelse.component';
import { SharedModule } from '../shared/shared.module';
import { TilpasHandlingerTilGodkendelseComponent } from './modals/tilpas-handlinger-til-godkendelse/tilpas-handlinger-til-godkendelse.component';
import { V2NotifikationModalComponent } from './modals/v2-notifikation-modal/v2-notifikation-modal.component';
import { SagerTilGodkendelseComponent } from './modals/sager-til-godkendelse/sager-til-godkendelse.component';

@NgModule({
    declarations: [
        D60Container,
        D60Component,
        PlanerTilGodkendelseContainer,
        PlanerTilGodkendelseComponent,
        PlanerGodkendtContainer,
        PlanerGodkendtComponent,
        KALAContainer,
        KALAComponent,
        SAKAContainer,
        SAKAComponent,
        AutorisationerContainer,
        AutorisationerComponent,
        PopupsContainer,
        PopupsComponent,
        SamtalelogContainer,
        SamtalelogComponent,
        RegnskabsaarTilGodkendelseComponent,
        TilpasHandlingerTilGodkendelseComponent,
        V2NotifikationModalComponent,
        SagerTilGodkendelseComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule
    ]
})

export class NotificationsModule {}
